import {createReducer, on} from "@ngrx/store";
import * as actions from "./menu.action";
import {MenuRelatedItemPayload} from "../../../../@domain/menu-related-item-payload";

export interface State {
  menuRelatedData: MenuRelatedItemPayload;
}

export const initialState: State = {
  menuRelatedData: {
    foodItem: [],
    quantity: [],
    section: [],
    category: [],
    activePos: []
  }
}

export const menuReducer = createReducer(
  initialState,
  on(actions.SET_MENU_RELATED_DATA, (state, { payload }) => {
    return {
      ...state,
      menuRelatedData: payload
    };
  })
);


